<template>
    <div class="midblock width100">
        <div
            v-if="payload && flightsReceived && flights.departOptions"
            class="width100 paddingtop20 marginright20 marginleft20"
        >
            <div class="floatleft lineheight40" style="display: inline-block;">
                Vanaf welke luchthaven wil je reizen?
            </div>
            <div
                class="select-drop paddingleft15 floatleft"
                style="display: inline-block; clear: none !important;"
            >
                <select
                    v-model="payload.flightDepartFrom"
                    v-on:change="$emit('flights-search-click')"
                    class="requiredfield"
                >
                    <option disabled value="">Selecteer luchthaven</option>
                    <option
                        v-for="option in flights.departOptions"
                        :value="option.value"
                        :key="'SelectAirport' + option.value"
                    >
                        Vertrek vanaf {{ option.text }}
                    </option>
                </select>
            </div>
        </div>

        <div class="clear"></div>

        <div
            v-if="
                !flightsReceived &&
                    !cruiseIsLocalDeparture &&
                    !flightsTooFarFuture
            "
            class="padding10 textleft"
        >
            <div class="yellow-notification">
                <font-awesome-icon icon="spinner" :spin="true" />
                We zijn op zoek naar de meest voordelige vluchten...
            </div>
        </div>

        <div
            v-if="
                flightsReceived &&
                    !cruiseIsLocalDeparture &&
                    !flightsTooFarFuture &&
                    Object.keys(flights.results).length === 0
            "
            class="padding20 textleft"
        >
            <div v-if="numberOfResults() === 0" class="yellow-notification">
              Er zijn <b>momenteel geen passende vluchten</b> gevonden,
              je kunt ervoor kiezen om nu alleen je cruise te boeken en
              eventueel je vluchtwensen door te geven in de volgende stap zodat
              wij op zoek kunnen naar de mogelijkheden.
            </div>
        </div>

        <div
            v-if="flightsTooFarFuture"
            class="padding20 textleft"
            v-on:click="$emit('flights-selected-click')"
        >
            <div class="yellow-notification">
              Het is nog net iets te vroeg om je vluchten te kiezen! Voor pakketreizen gebruiken we lijndiensten met speciale touroperator-tarieven. Vliegtickets worden zo’n 10 maanden voor de terugreis bekendgemaakt. Boek de cruise nu alvast om zeker te zijn van de prijs en beschikbaarheid. Vliegtickets later bijboeken? Dat kan, maar dan is het geen pakketreis.
            </div>
        </div>

        <table
            id="flights"
            v-if="flights && !flightsTooFarFuture"
            cellspacing="0px"
            cellpadding="10px"
            width="100%"
            class=" hoverme"

        >
            <tr
                v-on:click="removeSelectedAndEmit()"
                valign="middle"
                class="pointer"
                :class="{
                        selectedRow: !flightsSelected()
                    }"
            >
                <td align="center">
                    <input
                        type="radio"
                        name="flights"
                        value="NO"
                        :checked="!flightsSelected()"
                    />
                </td>
                <td>
                    <strong>Geen vluchten</strong>
                </td>
                <td valign="middle" :class="{ dim: flightsSelected() }">

                  <div v-if="!flightsSelected()" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold"

                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>

            <tr
                v-on:click="selectFlightAndEmit(emptyFlight)"
                valign="middle"
                class="pointer"
                :class="{
                        selectedRow:  flights.selectedGroup === emptyFlight
                    }"
            >
                <td align="center" style="border-top: 1px solid #ddd;">
                    <input
                        type="radio"
                        name="flights"
                        value="OFF"
                        :checked="flights.selectedGroup === emptyFlight"
                    />
                </td>
                <td style="border-top: 1px solid #ddd;">
                    <strong
                        >Zoek andere vluchten voor mij
                        <i>(prijs en beschikbaarheid op aanvraag)</i></strong
                    >
                </td>
                <td style="border-top: 1px solid #ddd;"
                    valign="middle"
                    :class="{
                        dim: flights.selectedGroup !== emptyFlight,
                    }"
                >

                  <div v-if="flights.selectedGroup === emptyFlight" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold"

                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>
            <tr
                v-for="(flight, flightIndex) in flights.results"
                v-on:click="selectFlight(flight)"
                :class="{ dim: !(flights.selectedGroup === flight),
                 selectedRow: flights.selectedGroup === flight}"
                :key="'flightResult' + flightIndex"
                class="pointer"

            >
                <td align="center" style="border-top: 1px solid #ddd;">
                    <div v-if="typeof flight.inbound[0] !== 'undefined'">
                        <flightLogo
                            :flightNumber="flight.inbound[0].flightNumber"
                        />
                    </div>
                    <div v-if="typeof flight.outbound[0] !== 'undefined' && flight.outbound[0].flightNumber.substring(0, 2) !== flight.inbound[0].flightNumber.substring(0,2)">
                        <flightLogo
                            :flightNumber="flight.outbound[0].flightNumber"
                        />
                    </div>
                    <input
                        type="radio"
                        name="flights"
                        :value="flightIndex"
                        :checked="flights.selectedGroup === flight"
                    />
                </td>
                <td style="border-top: 1px solid #ddd;">
                    <div v-if="typeof flight.outbound[0] !== 'undefined'">
                        <div style="float:left;width:5%;padding-right: 5px;">
                            <font-awesome-icon icon="plane" />
                        </div>

                        <div
                            class="width90"
                            style="float:left;width:calc(95% - 5px)"
                        >
                            <strong
                                >{{ flight.outbound[0].departureAirport }} -
                                {{ flight.outbound[0].arrivalAirport }}
                                -
                                {{
                                    moment(
                                        flight.outbound[0].departureDate
                                    ).format('D MMM YYYY')
                                }}
                            </strong>
                            <br />

                            Vertrek:
                            {{
                                moment(flight.outbound[0].departureDate).format(
                                    'ddd HH:mm'
                                )
                            }}
                            uur - Aankomst:
                            {{
                                moment(flight.outbound[0].arrivalDate).format(
                                    'ddd HH:mm'
                                )
                            }}
                            uur<br />
                        </div>
                    </div>

                    <div v-if="typeof flight.inbound[0] !== 'undefined'">
                        <div style="float:left;width:5%;padding-right: 5px;">
                            <font-awesome-icon icon="plane" flip="horizontal" />
                        </div>
                        <div
                            class="width90"
                            style="float:left;width:calc(95% - 5px)"
                        >
                            <strong
                                >{{ flight.inbound[0].departureAirport }} -
                                {{ flight.inbound[0].arrivalAirport }}
                                -
                                {{
                                    moment(
                                        flight.inbound[0].departureDate
                                    ).format('D MMM YYYY')
                                }}
                            </strong>
                            <br />

                            Vertrek:
                            {{
                                moment(flight.inbound[0].departureDate).format(
                                    'ddd HH:mm'
                                )
                            }}
                            uur - Aankomst:
                            {{
                                moment(flight.inbound[0].arrivalDate).format(
                                    'ddd HH:mm'
                                )
                            }}
                            uur<br />

                            <div v-if="false" class="floatright">
                                Incl. ruimbagage
                                <font-awesome-icon
                                    icon="suitcase-rolling"
                                    style="color:#41C04F"
                                />
                            </div>

                            <div class="floatright">
                              <div v-if="flight.outbound[0].flightNumber.substring(0, 2) === 'HV'">
                                Incl. klein handbagage
                                <font-awesome-icon icon="suitcase" />
                              </div>

                              <div v-else="">
                                Incl. handbagage
                                <font-awesome-icon icon="suitcase" />
                              </div>

                                Excl. ruimbagage (achteraf bij te boeken)
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="13" height="13"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M336 160H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h16v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h16c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48zm-16 216c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zM144 48h96v80h48V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v80h48V48z"/></svg>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix"></div>
                </td>
                <td align="center" style="border-top: 1px solid #ddd;">
                    <h1 class="paddingtop5 font18">
                        <span class="darkblue priceSpan">
                            € {{ roundPrice(flight.totalPrice / totalPax) }}
                            <small>p.p.</small></span
                        >
                    </h1>
                  <div v-if="  flights.selectedGroup === flight" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold"

                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import FlightLogo from './FlightLogo.vue'

export default {
    name: 'FlightSearch',
    data: function() {
        return {
            emptyFlight: {
                outbound: [
                    {
                        id: '0',
                        Identifier: 'offerte',
                        Direction: 'outbound',
                        departureAirport: this.payload.flightDepartFrom,
                        departureDate: '',
                        arrivalAirport: this.cruise.itinerary.days[1]
                            .haven_naam,
                        arrivalDate: '',
                        duration: '',
                        flightNumber: 'Aanvraag',
                    },
                ],
                inbound: [
                    {
                        id: '0',
                        Identifier: 'offerte',
                        Direction: 'inbound',
                        departureAirport: this.cruise.itinerary.days[
                            this.cruise.duur
                        ].haven_naam,
                        departureDate: '',
                        arrivalAirport: this.payload.flightDepartFrom,
                        arrivalDate: '',
                        duration: '',
                        flightNumber: 'Aanvraag',
                    },
                ],
                totalPrice: 0,
            },
        }
    },
    components: {
        FlightLogo,
    },
    props: {
        flights: Object,
        totalPax: Number,
        flightsReceived: Boolean,
        cruiseIsLocalDeparture: Boolean,
        flightsTooFarFuture: Boolean,
        payload: Object,
        cruise: Object,
        departOptions: Object,
        logResponse: Function,
    },
    methods: {
        selectFlightAndEmit: function(emptyFlight) {
            this.selectFlight(emptyFlight)
            this.$emit('flights-selected-click')
        },
        removeSelectedAndEmit: function() {
            this.removeSelectedFlights()
            this.$emit('flights-selected-click')
        },
        numberOfResults: function() {
            if (!this.flights) {
                return 0
            }
            if (!this.flights.filterSpec) {
                return 0
            }
            return (
                parseInt(this.flights.filterSpec.filteredOutbound) +
                parseInt(this.flights.filterSpec.filteredInbound)
            )
        },
        selectFlight: function(flight) {
            this.flights.selectedGroup = flight

            this.flights.selectedFlightOffer = flight.flightOffer;

            if (typeof flight.outbound[0] !== 'undefined') {
                this.flights.selectedOutbound = flight.outbound[0]
            } else {
                this.flights.selectedOutbound = {}
            }

            if (typeof flight.inbound[0] !== 'undefined') {
                this.flights.selectedInbound = flight.inbound[0]
            } else {
                this.flights.selectedInbound = {}
            }

            this.flights.totalPrice = flight.totalPrice
            this.$emit('flights-selected-click')
        },
        roundPrice: function(price) {
            let parsed = parseFloat(price).toFixed(2)
            return parsed
                .split('.')
                .join(',')
                .replace(',00', ',-')
        },
        removeSelectedFlights: function() {
            this.flights.selectedOutbound = {}
            this.flights.selectedInbound = {}
            this.flights.selectedGroup = {}
        },
        flightsSelected: function() {
            if (!this.flights) return false
            if (
                ((this.flights.selectedOutbound &&
                    this.flights.selectedOutbound.id) ||
                    (this.flights.selectedInbound &&
                        this.flights.selectedInbound.id)) &&
                this.flights.selectedGroup
            ) {
                return true
            }
        },
    },
    computed: {
        departAirportName: function() {
            let dptFrom = this.payload.flightDepartFrom
            if (!dptFrom || !this.flights.departOptions) {
                return ''
            }

            let ret = this.flights.departOptions.find(function(element) {
                return element.value === dptFrom
            })

            if (!ret || !ret.text) {
                return ''
            }
            return ret.text
        },
    },
}
</script>

<style lang="scss" scoped>
.priceSpan {
    white-space: nowrap;
}
</style>

<style scoped>
.selectedRow{
  background: #f3f9fd;
}
</style>